import React, { FC } from 'react'
import useTableTranslation from '@components/UI-Components/HierarchyWiseItemsTable/hooks/use-table-translation'
import { Column } from '@components/UI-Components/HierarchyWiseItemsTable/models/column'
import * as css from './QuantityHeaderWithKPI.css'
import Button from '@components/std-components/Button'
import classNames from 'classnames'
import { useObserver } from 'mobx-react-lite'
import useOrderContext from '@modules/order/hooks/use-order-context'
import useViewContext from '@modules/order/hooks/use-view-context'
import { ListUIStore } from '@modules/order/stores/view/List/ListUIStore'
import { nav } from '@stores/nav'
import { productCurveStore } from '@stores/productCurvesStore'
import { OrderType } from '@api/common'
import { getEnumValue } from '@utils/get-enum-value'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import { View } from '@modules/order/constants/views'
import useHierarchyItemTableContext from '@components/UI-Components/HierarchyWiseItemsTable/hooks/use-hierarchy-item-table-context'
import ProductQuantitiesUIStore from '@modules/showroom/productDetail/productQuantities/stores/ProductQuantitiesUIStore'
export interface CellProps {
  column?: Column
  customClass?: any
}

const RollUpButton: () => FC<CellProps> =
  () =>
  ({ column }) =>
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useObserver(function useHook() {
      const {
        uiStore: { isOrderEditable }
      } = useOrderContext()
      const viewContextVal = useViewContext()
      const { t } = useTableTranslation()
      const {
        queryParams: { clientId, buyingSessionGroupId, orderType, clientType, view }
      } = nav
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const productDetailsContextVal = useHierarchyItemTableContext()
      const uiStore = productDetailsContextVal.store as ProductQuantitiesUIStore

      const quantitiesUiStore =
        view === View.List ? (viewContextVal.uiStore as ListUIStore) : uiStore
      const { rollUpAllQuantities, areObjectsDataLoading } = quantitiesUiStore

      const hasGradeCurves = productCurveStore.hasGradeCurves(
        clientId,
        buyingSessionGroupId
      )

      const { label, field } = column
      const setAllProductQty = async () => {
        rollUpAllQuantities()
      }
      const isDoorOrder = orderType === OrderType.Door
      const isRetailView = clientType === getEnumValue(VIPClientType.Internal)
      const isGradingEnabled = !isRetailView && hasGradeCurves && !isDoorOrder

      return (
        <>
          <div className={classNames(css.cellWrapper, css['cell-border'])}>
            {!isDoorOrder &&
              !productCurveStore.getCurveLoading(clientId, buyingSessionGroupId) &&
              !isGradingEnabled && (
                <Button
                  onClick={() => setAllProductQty()}
                  disabled={areObjectsDataLoading || !isOrderEditable}
                  variant='link'
                  size='none'
                  className={css['btn']}
                >
                  <span className={css.cell} style={{ fontWeight: 'normal' }}>
                    {t(`order.rollUpAll`, 'Roll Up All')}
                  </span>
                </Button>
              )}
          </div>
          <div className={css.cellWrapper}>
            <span className={css.cell}>{t(`column.header.${field}.label`, label)}</span>
          </div>
        </>
      )
    })

export default RollUpButton
